export const userData = [
  {
    id: 'FfDe4cf4-4CAc-85B2-E83B-1Edcccd6017C',
    name: '超级管理员',
    account: 'admin',
    type: '超管',
    email: 'admin@uglcrwjix.sg',
    password: 'nXI6GFRk/nfEsmtrYn0aHyld9bpzfVAVIwF5vJbEGf0KKEeP9EwoI8LOkUm8R6Dvnnz4kRqMRFrcNd19zsnrFXYuPy6IBe86wPC49dMOSVmPlDNl050eZwiPRQ8Jv08IeNNL//cEjMQAEXf6IvodLfgIB6IGKMyfM98sQPu88aYBH6GbZCLz4KNznZ1oF0gD3R6K5KKoBdIFFiy9ld+weqm1W8GS6OabQ1YtnYJPXd+wxHeFjD2b3JA3wHZphjmLbEoE9qzCaghwj+q+lG+SB84O23+L/OIn91lQw/NhB8ESrp9WhjKcHAisHXt4pLv9i943850aKdyPqagbr9J0hA==',
    confirmPassword: 'nXI6GFRk/nfEsmtrYn0aHyld9bpzfVAVIwF5vJbEGf0KKEeP9EwoI8LOkUm8R6Dvnnz4kRqMRFrcNd19zsnrFXYuPy6IBe86wPC49dMOSVmPlDNl050eZwiPRQ8Jv08IeNNL//cEjMQAEXf6IvodLfgIB6IGKMyfM98sQPu88aYBH6GbZCLz4KNznZ1oF0gD3R6K5KKoBdIFFiy9ld+weqm1W8GS6OabQ1YtnYJPXd+wxHeFjD2b3JA3wHZphjmLbEoE9qzCaghwj+q+lG+SB84O23+L/OIn91lQw/NhB8ESrp9WhjKcHAisHXt4pLv9i943850aKdyPqagbr9J0hA==',
    status: '启用',
    creatDate: '2023-10-01 09:30:30',
    creator: '超级管理员',
    isAdmin: '1'
  },
  {
    name: '访客',
    type: '访客',
    account: 'visitor',
    password: 'E9pn8bf19Jf0GNxkzK52KtXIynmdKsBSjLuGIQ/OXn0POtMOVEDOcyccfnFIyN+IFapTzl/keiBshJr9lgG6cpu3nGQpbzYilCq7xw7zhlanczbpl3CUKmnawNULhD4B+b8XY+e4WhqTcKjo31Qs9MR8723wo2L2di/AfjzEIALPYrvG1zAKFityvsaKU9zdaz4tlPhLM/l5F2zoud7xQ74fYl2Q4WoYqQJGJtX960J7hElYbCSD9T32+QEFCpQpHPiBRpYR2zZl+tYdZUuXNgAXemu7Be2smxPl4webWpHx/nuvLc8n+KwM/tqR6wNgcYUpAE0TlPCCQ1GFBwWhsQ==',
    confirmPassword: 'BzB2WcUa5vaBRmjJPEJdyccGmulZsYXvzcAJym3k7LQNErNMtWOtiFX4USgRm7otUka0P3SjGVId/w8iXadv/8/HLjSYHh1EtAQrDACHWr7VFvpH3VJMKXbBPZCldt4FBe4k6JwRdPtP+eSEtPZs3MGrTGjuaCdzO+UI+MFvzKHNbCmt/KoqMF/68gBbf8YVTfq96rEsmnHlB3/uulnFROWbAz7FFoqD+ii8gAJE8MsnZu3Kemj/N19fyckh/2OC3jkEqVSXaF7KhQS/QQjc+gIt29LaPRbx0XkuAp5KKnBx1l2Dm2eb0LKVv5MJHPPZ0XSSHWMXiPl6ZpzokPDpaA==',
    status: '启用',
    email: '123456@qq.com',
    id: '6DD9CfbB-AA9c-4f73-8CF2-32E267fb8D58',
    creatDate: '2023-10-10 17:14:19',
    creator: '超级管理员',
    isAdmin: '0'
  }
];
